import { ScrollView } from "dripsy";
import { ScrollViewProps } from "react-native";

export const KeyboardAwareScrollView = (props: ScrollViewProps) => {
    return  <ScrollView {...props}/>
}
